// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/iconfont.css
// module id = BjtM
// module chunks = 2